import { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import MyTable from "../../components/Schedule/MyTable";
import InventoryTable from "../Inventory/InventoryTable";

const ListView = ({ issueBox }) => {
  const isMobile = useMediaQuery("(max-width: 800px)");
  const [rows, setRows] = useState([
    {
      id: 1,
      "S.No.": 1,
      Item: "Wheel Chocks",
      Quantity: "25",
      Image: <img src="/images/wheel.png " width={30} height={30} />,
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
    },
    {
      id: 2,
      "S.No.": 2,
      Item: "Firehouse",
      Quantity: "53",
      Image: <img src="/images/extinguisher.png " width={30} height={30} />,
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
    },
    {
      id: 3,
      "S.No.": 3,
      Item: "Medical",
      Quantity: "65",
      Image: <img src="/images/medicine.png " width={30} height={30} />,
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
    },
    {
      id: 4,
      "S.No.": 4,
      Item: "Wire",
      Quantity: "11",
      Image: <img src="/images/wire.png " width={30} height={30} />,
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
    },
  ]);

  let columns = [
    {
      field: "S.No.",
      headerName: "S. No.",
      sortable: false,
      flex: 1,
      minWidth: 60,
      filterable: false,
    },
    {
      field: "Item",
      headerName: "Item",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
    },
    {
      field: "Image",
      headerName: "Image",
      sortable: false,
      flex: 1,
      minWidth: 100,
      filterable: false,
      renderCell: (params) => params.row.Image,
    },
    {
      field: "Notes",
      headerName: "Notes",
      sortable: false,
      flex: 1,
      minWidth: 300,
      filterable: false,
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Link to="/firehouse/items/detail">
            <img src="/images/eye.svg" style={{ cursor: "pointer" }}></img>
          </Link>
          <img src="/images/edit.svg" style={{ cursor: "pointer" }}></img>
          <img src="/images/delete.svg" style={{ cursor: "pointer" }}></img>
          <img
            src="/images/info-icon.svg"
            onClick={issueBox}
            style={{ cursor: "pointer" }}
          ></img>
        </Box>
      ),
    },
  ];

  return (
    <>
      {isMobile ? (
        <InventoryTable
          rows={rows || {}}
          columns={columns.map((col) => {
            if (col.field === "Image") {
              return {
                ...col,
                renderCell: (row) => row.Image,
              };
            }
            return col;
          })}
          heading={1}
        />
      ) : (
        <MyTable
          rows={rows || []}
          columns={columns}
          checkboxSelection={false}
          // loading={tableLoading}
          hideFooter={true}
        />
      )}
    </>
  );
};

export default ListView;
